module.exports = __webpack_public_path__ + "img/mobile_banking_ktb.2950416b.png";